import { Button, Col, DatePicker, Form, Row, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { Constants, Roles } from 'common/constants';
import { PATHS } from '@routing/routes';
import { useDispatch, useSelector } from 'react-redux';
import { BoxOrderDeliveryViewModel } from 'common/models';
import { useEffect, useState } from 'react';
import { TransactionSelector } from '@features/Transaction';
import dayjs from 'dayjs';
import { UpdateReceivedKFSDate } from '../business/BookingBusiness';
import { AccountSelector } from '@features/Account';
export const ReceivedKFSDate = () => {
  const accountState = useSelector(AccountSelector);
  const history = useHistory();
  const transactionState = useSelector(TransactionSelector);
  const dispatch = useDispatch();
  const onFinish = async (values: BoxOrderDeliveryViewModel) => {
    const data = { ...transactionState.TransactionSummary?.Transactions }; // Create a shallow copy
    await dispatch(
      UpdateReceivedKFSDate({
        TransactionsId: data.Id ?? '',
        Date: values.Date ? values.Date : undefined,
      })
    );
    message.success('Date updated successfully');
    history.push(PATHS.TransactionSummary.path);
  };

  useEffect(() => {
    if (accountState.RoleName === Roles.Customer) {
      history.push(PATHS.Home.path);
    }
  }, []);
  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h1>Update date - Received with KFS agent</h1>
      </Row>

      <Form name="senderForm" layout="vertical" onFinish={onFinish}>
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={12} lg={8} xl={6}>
            <>
              <Form.Item
                label="Date"
                name="Date"
                initialValue={(() => {
                  const deliveryStatus = transactionState.TransactionSummary?.TransStatusDisplay?.find(
                    (x) => x.Code === 'ITRA'
                  );
                  return deliveryStatus?.CreatedDate ? dayjs(deliveryStatus.CreatedDate, 'DD/MM/YYYY hh:mm A') : '';
                })()}
                // rules={
                //   (transactionState.TransactionSummary?.TransStatusDisplay?.length || 0) > 3
                //     ? [{ required: true, message: Constants.REQUIRED_FIELD }]
                //     : []
                // }
                rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
              >
                <DatePicker size="large" className="full-width" placeholder="Date" format="YYYY-MM-DD" />
              </Form.Item>
            </>

            <div>
              <Button
                className="prevSenderBtn"
                size="large"
                type="default"
                onClick={() => history.push(PATHS.TransactionSummary.path)}
              >
                {Constants.BTN_BACK}
              </Button>
              <Button className="nextSenderBtn" size="large" type="primary" htmlType="submit">
                {Constants.BTN_UPDATE}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
